import React from 'react';
import Loader from '../../components/loader';
import { useDeliveryOrderBatches } from './apiHooks';
import { FormattedMessage, injectIntl } from 'react-intl';
import AdminRouteOptimisationUserTable from './adminRoutePlanDeliveryOrderBatchTable';

const AdminRoutePlanV2Addresses = ({ deliveryDay }) => {
  const { deliveryOrderBatches, isLoading: loadingDeliveryOrderBatches } = useDeliveryOrderBatches({
    deliveryDayId: deliveryDay.id,
  });
  const allAddressesHaveCoordinates = deliveryOrderBatches?.every((dob) => !!dob?.address?.coordinates);

  if (loadingDeliveryOrderBatches) {
    return <Loader show={true} />;
  }

  if (!deliveryOrderBatches || !deliveryOrderBatches.length) {
    return (
      <div className="alert alert-warning">
        <FormattedMessage id={'admin.route.planning.create.order.batches.not.created'} />
      </div>
    );
  }

  return (
    <>
      <h3>
        <FormattedMessage id={'admin.route.planning.create.customers.header'} />
      </h3>
      {!allAddressesHaveCoordinates ? (
        <div className="alert alert-warning">
          <FormattedMessage id={'admin.route.planning.create.customers.coordinates.missing'} />
        </div>
      ) : (
        ''
      )}
      <AdminRouteOptimisationUserTable deliveryOrderBatches={deliveryOrderBatches} />
      <div className="m-b-3">
        <FormattedMessage
          id={'admin.route.planning.create.customers.count'}
          values={{ count: deliveryOrderBatches.length }}
        />
      </div>
    </>
  );
};

export default injectIntl(AdminRoutePlanV2Addresses);
